import { web3Util } from '../utils/web3Util';
import { tx } from './tx';

export default async function claimAirdrop(amount: string, proof: string[]) {
  const contract = web3Util.getContract('claim');
  return tx(contract.methods.claim(amount, proof));
}
